const components = require.context('./', true, /\.vue$/);

export default Vue => {
	components.keys().map(item => {
		Vue.component(components(item).default.name, components(item).default);
	});
};